import { Controller } from "stimulus";
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'

export default class extends Controller {
  static targets = ['download']

  connect() {
    this.downloadTarget.addEventListener("click", (e) => this.downloadPdf(e));
  }

  downloadPdf(e) {
    e.preventDefault();
    const doc = new jsPDF();

    doc.text("Report", 15, 10);

    doc.text(" ", 15, 10);
    autoTable(doc, {html: '#report-table'});

    doc.save("report.pdf");
  }


  showDropdown(event) {
    const reportsTypeDropdown = event.target.parentNode.parentNode.children[1];
    if(reportsTypeDropdown.classList.contains("active")){
        reportsTypeDropdown.classList.remove("active");
    }else{
        reportsTypeDropdown.classList.add("active");
    }
  }
}